import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "assign-professional-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = {
  key: 0,
  class: "provider-list"
}
const _hoisted_4 = ["onClick", "onKeydown"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "provider-initials"
}
const _hoisted_7 = { class: "provider-meta" }
const _hoisted_8 = { class: "provider-title" }
const _hoisted_9 = { class: "provider-subtitle" }
const _hoisted_10 = {
  key: 1,
  class: "text-muted text-body-2"
}
const _hoisted_11 = {
  key: 0,
  class: "assign-error text-caption"
}

import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useModalStore } from "@/shared/stores/modal";
import { ref } from "vue";
import { assignAppointmentServiceProvider } from "@/shared/services/appointments.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssignProfessionalModal',
  props: {
    appointment: {},
    providers: {},
    onAssigned: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const providers = props.providers;

const selectedProviderId = ref<string>("");
const isAssigning = ref(false);
const assignError = ref("");

function getProviderId(p: any): string | number {
  return p?.vendor_user_id ?? p?.id ?? p?.user_id ?? p?.staff_id ?? p?._id ?? p?.client_id ?? p?.email ?? p?.name;
}

function getProviderTitle(p: any): string {
  return String(p?.name ?? p?.full_name ?? p?.display_name ?? "Professional");
}

function getProviderAvatarUrl(p: any): string {
  return String(
    p?.avatar ??
      p?.primary_avatar ??
      p?.profile?.avatar ??
      p?.client?.avatar ??
      p?.client?.primary_avatar ??
      ""
  ).trim();
}

function getProviderInitials(p: any): string {
  const name = getProviderTitle(p).trim();
  if (!name) return "?";
  const parts = name.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
  return (first + last).toUpperCase() || "?";
}

function getProviderSubtitle(p: any): string {
  const email = String(p?.email ?? "").trim();
  const phone = String(p?.phone ?? "").trim();
  return [email, phone].filter(Boolean).join(" • ");
}

const filteredProviders = providers;

function selectProvider(provider: any) {
  selectedProviderId.value = String(getProviderId(provider));
}

async function handleAssigned() {
  if (!selectedProviderId.value || isAssigning.value) return;

  assignError.value = "";
  isAssigning.value = true;

  const provider =
    filteredProviders.find((p) => String(getProviderId(p)) === selectedProviderId.value) || null;
  const appointmentId = props.appointment?.id ?? props.appointment?.appointment_id;
  const providerId = provider?.vendor_user_id ?? provider?.id;
  try {
    if (!appointmentId) throw new Error("Missing appointment id");
    if (!providerId) throw new Error("Missing provider id");

    await assignAppointmentServiceProvider(appointmentId, { provider_id: providerId });
    props.onAssigned?.(props.appointment, provider);
    modal.close();
  } catch (err: any) {
    assignError.value =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Failed to assign professional";
  } finally {
    isAssigning.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "modal-card",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, {
          class: "modal-toolbar",
          density: "comfortable",
          flat: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                class: "back-btn",
                "aria-label": "Back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-arrow-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-title" }, "Assign professional", -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "body py-6" }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hint" }, " Select a professional to assign to this appointment. ", -1)),
            (_unref(filteredProviders).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredProviders), (provider) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: String(getProviderId(provider)),
                      class: _normalizeClass(["provider-card", { 'provider-card--selected': selectedProviderId.value === String(getProviderId(provider)) }]),
                      role: "button",
                      tabindex: "0",
                      onClick: ($event: any) => (selectProvider(provider)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (selectProvider(provider)), ["prevent"]), ["enter"]),
                        _withKeys(_withModifiers(($event: any) => (selectProvider(provider)), ["prevent"]), ["space"])
                      ]
                    }, [
                      _createVNode(_component_v_avatar, {
                        size: "40",
                        color: "primary",
                        variant: "tonal",
                        class: "provider-avatar"
                      }, {
                        default: _withCtx(() => [
                          (getProviderAvatarUrl(provider))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: getProviderAvatarUrl(provider),
                                alt: "Provider avatar",
                                loading: "lazy"
                              }, null, 8, _hoisted_5))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(getProviderInitials(provider)), 1))
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(getProviderTitle(provider)), 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(getProviderSubtitle(provider)), 1)
                      ])
                    ], 42, _hoisted_4))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, " No providers found. "))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, { class: "actions" }, {
          default: _withCtx(() => [
            (assignError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(assignError.value), 1))
              : _createCommentVNode("", true),
            _createVNode(AppButtonFlat, {
              block: "",
              "prepend-icon": "mdi-account-check-outline",
              loading: isAssigning.value,
              disabled: !selectedProviderId.value || isAssigning.value,
              onClick: handleAssigned
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Assign ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})